import "core-js/modules/es.array.push.js";
export default {
  name: 'features-card',
  props: {
    featuresList: {
      type: Array,
      required: true
    }
  },
  computed: {
    needReverseIndexArray() {
      const array = [];
      for (let i = 0; i < this.featuresList.length - 1; i += 1) {
        array.push(4 * (i + 1) - 2);
        array.push(4 * (i + 1) - 2 + 1);
      }
      return array;
    }
  }
};